export default {
  meta: {
    title: '销售单详情'
  }
};

